"use strict";

exports.__esModule = true;
exports.DataTableColumnFields = DataTableColumnFields;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Fields = require("./Fields");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Well = _styledComponents["default"].div.withConfig({
  displayName: "DataTableColumnFields__Well",
  componentId: "sc-1yncnu4-0"
})(["margin-bottom:20px;"]);
var isNonFilterableColumn = function isNonFilterableColumn(type) {
  var nonFilterableColumnTypes = ["date", "duration"];
  return nonFilterableColumnTypes.includes(type);
};

/**
 * Fields for DataTableColumnElement.
 */
function DataTableColumnFields(props) {
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var _element$props = element.props,
    name = _element$props.name,
    canSort = _element$props.canSort,
    enableSorting = _element$props.enableSorting,
    defaultSortOrder = _element$props.defaultSortOrder,
    defaultWidth = _element$props.defaultWidth,
    type = _element$props.type,
    canFilter = _element$props.canFilter,
    exactMatch = _element$props.exactMatch,
    defaultFilterValue = _element$props.defaultFilterValue,
    usePlantTime = _element$props.usePlantTime,
    dateFormat = _element$props.dateFormat;
  var isExactMatch = exactMatch !== false;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Fields.TitleField, {
    value: name,
    setProp: function setProp(val) {
      return elementEditor.setProps(path, {
        name: val,
        titleOverridden: !!val
      });
    }
  }), canSort !== false && /*#__PURE__*/_react["default"].createElement(_Fields.SortableField, {
    enableSort: enableSorting,
    setSortable: function setSortable(val) {
      return elementEditor.setProp(path, "enableSorting", val);
    },
    defaultSortOrder: defaultSortOrder || "NONE",
    setSortOrder: function setSortOrder(val) {
      return elementEditor.setProp(path, "defaultSortOrder", val);
    }
  }), /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTable.defaultColumnWidth.label", "Column Width (in pixels)"),
    helperText: translate("DataTable.defaultColumnWidth.helperText", "Leave it blank for auto width")
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    min: 0,
    onValueChange: function onValueChange(value) {
      return elementEditor.setProp(path, "defaultWidth", value);
    },
    value: defaultWidth ? defaultWidth : ""
  }))), !isNonFilterableColumn(type) && /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    disabled: isNonFilterableColumn(type),
    label: translate("DataTableFields.showFilter.label", "Enable Filtering"),
    checked: !isNonFilterableColumn(type) && canFilter,
    onChange: function onChange() {
      var nextCanFilter = !canFilter;
      var updates = {
        canFilter: nextCanFilter
      };
      if (nextCanFilter) {
        updates.exactMatch = true;
      }
      elementEditor.setProps(path, updates);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    disabled: !canFilter,
    label: translate("DataTableFields.exactMatch.label", "Exact match"),
    checked: isExactMatch,
    onChange: function onChange() {
      elementEditor.setProp(path, "exactMatch", !isExactMatch);
    }
  }), !isNonFilterableColumn(type) && canFilter && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTable.defaultFilterValue.label", "Default filter value")
  }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    disabled: !canFilter,
    key: name,
    value: defaultFilterValue,
    onInput: function onInput(e) {
      elementEditor.setProp(path, "defaultFilterValue", e.target.value);
    }
  })))), type === "date" && /*#__PURE__*/_react["default"].createElement(_Fields.DateFormatField, {
    usePlantTime: usePlantTime,
    dateFormat: dateFormat,
    setDateFormat: function setDateFormat(val) {
      return elementEditor.setProp(path, "dateFormat", val);
    }
  }));
}